import React, { Component } from "react";
import { View, StyleSheet, ScrollView, TouchableHighlight } from "react-native";
import Text from "../components_v2/TextFont";
import { connect } from "react-redux";

import ArButton from "../argon-ui/Button";
import ArTheme from "../argon-ui/Theme";

import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import { faPlus } from "../../assets/consts/faCharCodes";

class CameraListScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      serverUrl: undefined,
      accessToken: undefined,
    };
  }

  componentDidMount() {}

  render() {
    return (
      <View style={{ flex: 1 }}>
        <ScrollView>
          {this.props.reducer.cameras.map((c, i) => {
            return (
              <TouchableHighlight
                underlayColor="#eee"
                onPress={() => {
                  this.props.navigation.navigate("CameraForm", {
                    cameraId: c.cameraId,
                  });
                }}
                key={c.cameraId}
                style={{
                  padding: 10,
                  borderBottomWidth: 1,
                  borderColor: ArTheme.COLORS.MUTED,
                  alignItems: "center",
                  height: 47,
                }}
              >
                <Text>{c.cameraName}</Text>
              </TouchableHighlight>
            );
          })}
        </ScrollView>
        <TouchableHighlight
          underlayColor="transparent"
          style={styles.btnAdd}
          onPress={() => this.props.navigation.navigate("CameraForm")}
        >
          <FontAwesomeIcon icon={faPlus} color="#FFF" size={30} />
        </TouchableHighlight>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  btnAdd: {
    backgroundColor: ArTheme.COLORS.PRIMARY,
    width: 60,
    height: 60,
    borderRadius: 30,
    position: "absolute",
    bottom: 15,
    shadowColor: "#000",
    shadowRadius: 5,
    elevation: 10,
    alignSelf: "center",
  },
});

const mapStateToProps = (state) => {
  return {
    reducer: state.CameraReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CameraListScreen);
